<template>
  <DefaultSection class="section is-medium checklist">
    <div class="container">
      <div class="columns">
        <div class="column is-8-tablet is-offset-1">
          <h2 class="title is-size-medium has-text-weight-bold mb-6">
            {{ title }}
          </h2>
          <div
            class="content checklist has-text-weight-semibold"
            v-html="text"
          />
          <div class="mt-6">
            <VuepalLink
              v-if="link && link.url"
              :to="link.url.path"
              class="button is-lessmess-desk large has-text-weight-bold is-size-6"
            >
              {{ link.title }}
            </VuepalLink>
          </div>
        </div>
      </div>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphCallToActionFragment } from '#graphql-operations'

withDefaults(
  defineProps<{
    title?: string
    text?: string
    link?: ParagraphCallToActionFragment['link']
  }>(),
  {
    title: '',
    text: '',
    link: undefined,
  },
)

defineBlokkli({
  bundle: 'check_list',
})
</script>

<style scoped lang="scss">
.checklist {
  background-color: $background-gray;
  ::v-deep(ul) {
    //list-style-image: url('~/assets/svgs/icons/check-outline.svg');
    margin-left: 0;

    li {
      list-style: none;
      padding-left: 40px;
      padding-bottom: 20px;

      background-image: url('~/assets/svgs/icons/check-outline.svg');
      background-repeat: no-repeat;
      background-position: left 0px;

      //&:before {
      //  position: relative;
      //  display: inline-block;
      //  content: '\2022'; /* bullet point, for screen readers */
      //  text-indent: -999999px; /* move the bullet point out of sight */
      //  left: -2rem;
      //  width: 1.5rem; /* desired width of the image */
      //  height: 2rem; /* unrelated to image height; this is so it gets snipped */
      //  background-repeat: no-repeat;
      //  background-image: url('~/assets/svgs/icons/check-outline.svg');
      //  background-size: 1.5rem 2rem;
      //  background-position: 0 -0.3rem;
      //}
    }
  }
}
</style>
